import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import MappingWindow from "../mapping/MappingWIndow";

function ContactMappings() {
  const [filteredFields, setFilteredFields] = useState([]);

  const {
    mapping: {
      defaultMappings: { customer: mappings },
    },
    hubspot: {
      hubspotDropdownFields: { customer: hsFields },
      loading: hubspotLoading,
    },
    tripletex: {
      tripletexDropdownFields: { customer: txFields },
      loading: txLoading,
    },
  } = useSelector((state) => state.mapping);

  useEffect(() => {
    if (hsFields && hsFields.length > 0) {
      const filtered = hsFields.filter((field) => field.CRF !== "doNotAdd");
      setFilteredFields(filtered);
    }
  }, [hsFields]);

  return (
    <div>
      <MappingWindow
        mapping={mappings}
        hubspotDropdownFields={filteredFields}
        tripletexDropdownFields={txFields}
        mappingsFor="customer"
        hubspotLoading={hubspotLoading}
        txLoading={txLoading}
        path="cmsContent.contacts.contactFieldMappings"
      />
    </div>
  );
}

export default ContactMappings;
